import { isEmpty } from '@sgme/fp';
import { useGimmickSwitchInfos } from 'components/common-form/hooks/useGimmickSwitchInfos';
import { GimmickSelector } from 'components/shared/GimmickSelector';
import { FC } from 'react';

interface GimmickSelectorFieldProps {
  fieldIds: readonly string[];
  isDisabled: boolean;
  className?: string;
}
export const GimmickSelectorField: FC<GimmickSelectorFieldProps> = ({ fieldIds, isDisabled, className }) => {
  const [selected, available, setValue] = useGimmickSwitchInfos(fieldIds);

  if (isEmpty(available)) {
    return null;
  }

  return (
    <GimmickSelector
      selected={selected}
      available={available}
      className={className}
      onGimmickSelectedChanged={setValue}
      isDisabled={isDisabled}
    />
  );
};

GimmickSelectorField.displayName = 'GimmickSelectorField';
